import { FC } from "react";
import { components, MenuProps } from "react-select";

import { ResetDefaultsButton } from "./reset-defaults-button";

type IViewDropdownMenuProps = MenuProps;

export const ViewDropdownMenu: FC<IViewDropdownMenuProps> = props => {
  return (
    <components.Menu {...props}>
      {props.children}
      <ResetDefaultsButton />
    </components.Menu>
  );
};
